import React, { useEffect, useState } from "react";
import Header from "./Header";
import apiService from "../Services/apiService";
import { useNavigate, useParams,Link } from "react-router-dom";
import { Modal, Box, Typography } from '@mui/material';

const AddPermission = () => {
    const token = localStorage.getItem("JWTToken");
    const { uniqueKey } = useParams();
    const [permissionData, setPermissionData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOpenEditModal, setIsOpenEditModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [formData, setFormData] = useState({
        Email: "",
        CanEdit: 0,
        CanEnd: 0,
    });
    const redirect = useNavigate(); 
    useEffect(() => {
        const getPermissionData = async () => {
            debugger;
            try {
                const response = await apiService.GetPermissionData(token, uniqueKey);
                if (response) {
                    if(response.Permission_DETAILS){
                        setPermissionData(response.Permission_DETAILS);
                    }else{
                        setPermissionData(null)
                    }
                } else {
                }
            } catch (error) {
                throw error;
            } finally {
                setLoading(false);
            }
        };

        if (token && uniqueKey) {
            getPermissionData();
        } else {
            redirect("/Login"); 
        }
    }, [token, uniqueKey]);

    const handleOpen = () => setIsModalOpen(true);
    const handleClose = () => setIsModalOpen(false);

    const EdithandleOpen = (rowData) => {
        console.log(rowData)
        setSelectedRow(rowData);
        setIsOpenEditModal(true);
    };
    const EdithandleClose = () => {
        setIsOpenEditModal(false);
        setSelectedRow(null); 
    };
    const DeletePermission =async(SurveyID) => {
        try {
            const isConfirmed = window.confirm("Are you sure you want to delete this survey?");
            if (isConfirmed) {
            const response =await apiService.DeletePermission(token, uniqueKey,SurveyID)
            if (response) {
                alert("deleted successfully");
                setPermissionData((prevData) => prevData.filter((item) => item.SharedID !== SurveyID)); // Filter out the deleted item
            } else {

            }
        }
        } catch (error) {

        }
    }
    const CreatePermission = async () => {
        try {
            const response =await apiService.CreatePermission(token,uniqueKey,formData.Email,formData.CanEdit,formData.CanEnd)
            if (response) {
                const updatedPermissions = await apiService.GetPermissionData(token, uniqueKey);
                setPermissionData(updatedPermissions.Permission_DETAILS || []);
                setIsModalOpen(false)
                alert("Created Successfully");
            } else {
                alert("Not Created");
            }
        } catch (error) {
            throw error
        }
    }
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? (checked? 1 : 0) : value,
        }));
    };
    const UpdatePermissionData=async()=>{
        if (!selectedRow) {
            alert("No permission selected for update.");
            return;
        }
        const updatedData = {
            SharedID: selectedRow.SharedID,
            Email: selectedRow.Email,
            CanEdit: selectedRow.CanEdit,
            CanEnd: selectedRow.CanEnd,
        };
        try {
            const response = await apiService.UpdatePermission(token, uniqueKey, updatedData.SharedID, updatedData.Email, updatedData.CanEdit, updatedData.CanEnd);
            if (response) {
                const updatedPermissions = await apiService.GetPermissionData(token, uniqueKey);
                setPermissionData(updatedPermissions.Permission_DETAILS || []);
                setIsOpenEditModal(false)
            }
        } catch (error) {
            throw error
        }
    }
    return (
        <>
            <Header />
            {loading ? (
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            ) : (
                <div className="py-3 bg-grey">
                        <div className="container py-5">
                            <h5>
                                <Link className="text-dark" to={"/SurveyList"}>Dashboard</Link> / <Link className="text-dark" to={`/ManageSurvey/${uniqueKey}`}>Manage Survey</Link> / Add Permission</h5>
                        </div>
                    <div className="container bg-grey min-hight85vh">
                        <div className="text-end">
                                <button className="py-1 px-4 border-0 Gold br-5" onClick={handleOpen}>+ Add Permission</button>
                                <Modal
                                    open={isModalOpen}
                                    onClose={handleClose}
                                    aria-labelledby="modal-title"
                                    aria-describedby="modal-description"
                                >
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            bgcolor: 'background.paper',
                                            borderRadius: 2,
                                            boxShadow: 24,
                                            p: 4,
                                            width: 600,
                                        }}
                                    >
                                        <h4 id="modal-title" className="text-center" sx={{ mt: 2 }}>
                                            Permission Add
                                        </h4>
                                        <Typography id="modal-description" sx={{ mt: 2 }}>
                                            <div>
                                                <div className="mb-3">
                                                <label htmlFor="">Email</label>
                                                <input type="Email" className="Sanket-Control"  name="Email" value={formData.Email} onChange={handleInputChange}/>
                                                </div>
                                                <div>
                                                    <input type="checkbox" className="ms-3" name="CanEdit" checked={formData.CanEdit} onChange={handleInputChange}/> Can Edit
                                                    <input type="checkbox" className="ms-3" name="CanEnd" checked={formData.CanEnd} onChange={handleInputChange}/> Can End
                                                </div>
                                            </div>
                                        </Typography>
                                        <Box sx={{ mt: 3, display: 'flex',justifyContent:'end' }}>
                                            <button className="text-dark ActionBtns" onClick={handleClose}>
                                                Close
                                            </button>
                                            <button
                                                className={`py-1 px-4 border-0 Gold br-5`}
                                                onClick={CreatePermission}
                                            > Add Permission</button>
                                        </Box>
                                    </Box>
                                </Modal>
                            </div>
                            <div className="overflow-auto">
                            {/* Render Permission Data */}
                            <table className="table mt-3">
                                <thead>
                                    <tr>
                                        <th className="bg-grey2 text-grey">Sr. No</th>
                                        <th className="bg-grey2 text-grey text-center">Email</th>
                                        <th className="bg-grey2 text-grey text-center">Can View</th>
                                        <th className="bg-grey2 text-grey text-center">Can Edit</th>
                                        <th className="bg-grey2 text-grey text-center">Can End</th>
                                        <th className="bg-grey2 text-grey text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {permissionData && permissionData.length > 0 ? (
                                        permissionData.map((data, index) => (
                                            <tr key={index}>
                                                <td className="text-grey p-2">{++index}</td>
                                                <td className="text-grey text-center p-2 m-2">{data.Email}</td>
                                                <td className="text-grey text-center p-2 m-2">{data.CanView!==0?"YES":"NO"}</td>
                                                <td className="text-grey text-center p-2 m-2">{data.CanEdit!==0?"YES":"NO"}</td>
                                                <td className="text-grey text-center p-2 m-2">{data.CanEnd!==0?"YES":"NO"}</td>
                                                <td className="text-grey text-center p-2 m-2">
                                                    <button className="ActionBtns m-0" onClick={()=>{DeletePermission(data.SharedID)}}>
                                                    <i className="fa-solid fa-trash"></i>
                                                    </button>
                                                    <button className="ActionBtns m-0" onClick={()=>{EdithandleOpen(data)}}><i className="fa-regular fa-pen-to-square"></i></button>
                                                    <Modal
                                                        open={isOpenEditModal}
                                                        onClose={EdithandleClose}
                                                        aria-labelledby="modal-title"
                                                        aria-describedby="modal-description"
                                                    >
                                                        <Box
                                                            sx={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '50%',
                                                                transform: 'translate(-50%, -50%)',
                                                                bgcolor: 'background.paper',
                                                                borderRadius: 2,
                                                                boxShadow: 24,
                                                                p: 4,
                                                                width: 600,
                                                            }}
                                                        >
                                                            <h4 id="modal-title" className="text-center" sx={{ mt: 2 }}>
                                                               Update Permission 
                                                            </h4>
                                                            <Typography id="modal-description" sx={{ mt: 2 }}>
                                                                <div>
                                                                    <input type="hidden" value={selectedRow?.SharedID || ""} className="d-none"/>
                                                                    <div className="mb-3">
                                                                        <label htmlFor="">Email</label>
                                                                        <input type="Email" className="Sanket-Control bg-grey" value={selectedRow?.Email || ""} readOnly={true}/>
                                                                    </div>
                                                                    <div>
                                                                        <input type="checkbox" className="ms-3" checked={selectedRow?.CanEdit !== 0}  onChange={(e) => setSelectedRow({ ...selectedRow, CanEdit: e.target.checked ? 1 : 0 })}/> Can Edit
                                                                        <input type="checkbox" className="ms-3" checked={selectedRow?.CanEnd !== 0}  onChange={(e) => setSelectedRow({ ...selectedRow, CanEnd: e.target.checked ? 1 : 0 })}/> Can End
                                                                    </div>
                                                                </div>
                                                            </Typography>
                                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'end' }}>
                                                                <button className="text-dark ActionBtns" onClick={EdithandleClose}>
                                                                    Close
                                                                </button>
                                                                <button
                                                                    className={`py-1 px-4 border-0 Gold br-5`}
                                                                    onClick={()=>{UpdatePermissionData()}}
                                                                > Edit Permission</button>
                                                            </Box>
                                                        </Box>
                                                    </Modal>
                                                </td>
                                            </tr>
                                        ))
                                    ) :
                                        (
                                            <tr>
                                                <td colSpan={7} className="text-center">no data found</td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddPermission;
